const IDBExportImport = require('indexeddb-export-import');

let version = 1;

export const DataBases = Object.freeze({
    RrwebDB: 'RrwebDB'
});

export const Stores = Object.freeze({
    UserEvents: 'UserEvents',
    ImagensApp: 'ImagensApp'
});

export const initDB = (dataBase, storeName) => {
    return new Promise((resolve) => {
        let request = indexedDB.open(dataBase);

        // if the data object store doesn't exist, create it
        request.onupgradeneeded = () => {
            let db = request.result;

            if (!db.objectStoreNames.contains(storeName)) {
                db.createObjectStore(storeName, { keyPath: 'id' });
            }
            // no need to resolve here
        };

        request.onsuccess = (e) => {
            let db = request.result;
            // get current version and store it
            version = db.version;
            resolve(request.result);
        };

        request.onerror = (e) => {
            resolve(false);
        };
    });
}

export const addData = (dataBase, storeName, data) => {
    return new Promise((resolve) => {
        let request = indexedDB.open(dataBase);

        request.onsuccess = () => {
            try {
                let db = request.result;
                const tx = db.transaction(storeName, 'readwrite');
                const store = tx.objectStore(storeName);
                store.add(data);
                resolve(data);
            } catch (err) {
                console.log('addData', err);
                resolve(err);
            }
        };

        request.onerror = () => {
            const error = request.error?.message
            if (error) {
                resolve(error);
            } else {
                resolve('Unknown error');
            }
        };
    });
};

export const retrieveListData = (dataBase, storeName, timeStampInitial, timeStampFinal) => {
    return new Promise((resolve) => {
        let request = indexedDB.open(dataBase);

        request.onsuccess = () => {
            try {
                let db = request.result;
                const keyRangeValue = IDBKeyRange.bound(timeStampInitial, timeStampFinal);

                const tx = db.transaction(storeName, 'readwrite');
                const objectStore = tx.objectStore(storeName);

                let listData = [];

                objectStore.openCursor(keyRangeValue).onsuccess = (event) => {
                    const cursor = event.target.result;
                    if (cursor) {
                        listData.push(cursor.value);

                        cursor.continue();
                    } else {
                        resolve(listData);
                    }
                };
            } catch (err) {
                console.log('retrieveListData', err);
                resolve([]);
            }
        };
    });
};

export const clearData = (dataBase, storeName, timeStamp) => {
    return new Promise((resolve) => {
        let request = indexedDB.open(dataBase);

        request.onsuccess = () => {
            try {
                let db = request.result;
                const keyRangeValue = IDBKeyRange.upperBound(timeStamp);

                const tx = db.transaction(storeName, 'readwrite');
                const objectStore = tx.objectStore(storeName);

                let listClearedData = [];

                objectStore.openCursor(keyRangeValue).onsuccess = (event) => {
                    const cursor = event.target.result;

                    if (!cursor)
                        return;

                    listClearedData.push(cursor.value);
                    cursor.delete();
                    cursor.continue();
                };

                resolve(listClearedData);
            } catch (err) {
                console.log('clearData', err);
                resolve(err);
            }
        }

        request.onerror = () => {
            const error = request.error?.message
            if (error) {
                resolve(error);
            } else {
                resolve('Unknown error');
            }
        }
    });
};

export const exportDataBaseToJson = (dataBase) => {
    return new Promise((resolve) => {
        let request = indexedDB.open(dataBase);

        request.onsuccess = () => {
            try {
                let db = request.result;

                IDBExportImport.exportToJsonString(db, (err, jsonString) => {
                    resolve(jsonString);
                })
            } catch (err) {
                console.log('exportDataBaseToJson', err);
                resolve(err);
            }
        }

        request.onerror = () => {
            const error = request.error?.message
            if (error) {
                resolve(error);
            } else {
                resolve('Unknown error');
            }
        }
    });
}

export const importDataBaseFromJson = (dataBase, jsonString) => {
    return new Promise((resolve) => {
        let request = indexedDB.open(dataBase);

        request.onsuccess = () => {
            try {
                let db = request.result;

                IDBExportImport.importFromJsonString(db, jsonString, (err) => {
                    if (!err)
                        resolve('Imported data successfully');
                    else
                        resolve(err);
                });
            } catch (err) {
                console.log('importDataBaseFromJson', err);
                resolve(err);
            }
        }

        request.onerror = () => {
            const error = request.error?.message
            if (error) {
                resolve(error);
            } else {
                resolve('Unknown error');
            }
        }
    });
}